import { Component } from '@angular/core';

@Component({
  selector: 'app-view-row',
  templateUrl: './view-row.component.html',
  styleUrls: ['./view-row.component.scss']
})
export class ViewRowComponent {

}
